import { css, html } from 'react-strict-dom';

import Button from '../../../components/Button';
import Text from '../../../components/Text';
import ReportStatusTag from './ReportStatusTag';

type Props = {
  approved: boolean;
  /** Whether the user may approve or revoke a period. */
  canApprove: boolean;
  /** e.g. "September", used in the approve button label. */
  periodName: string;
  busy?: boolean;
  onApprove: () => void;
  onRevoke: () => void;
};

/**
 * Sign-off for the period on screen.  Agency owners approve a period to let
 * the client see it, and can revoke it again; clients never see the control.
 */
export default function ReportApproval({
  approved,
  canApprove,
  periodName,
  busy,
  onApprove,
  onRevoke,
}: Props) {
  if (approved) {
    return (
      <html.div style={styles.row}>
        <ReportStatusTag label="Visible to client" variant="green" />
        {canApprove && (
          <Button
            label="Revoke"
            variant="text"
            colorScheme="black"
            disabled={busy}
            onClick={onRevoke}
          />
        )}
      </html.div>
    );
  }

  return (
    <html.div style={styles.row}>
      <Text
        typeface="body.small.medium"
        color="neutral60"
        style={styles.unapprovedFull}
      >
        Not visible to the client yet
      </Text>
      <Text
        typeface="body.small.medium"
        color="neutral60"
        style={styles.unapprovedShort}
      >
        Not visible yet
      </Text>
      {canApprove && (
        <Button
          label={`Approve ${periodName}`}
          disabled={busy}
          onClick={onApprove}
        />
      )}
    </html.div>
  );
}

const styles = css.create({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 12,
  },
  unapprovedFull: {
    display: 'inline',
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
  unapprovedShort: {
    display: 'none',
    '@media (max-width: 768px)': {
      display: 'inline',
    },
  },
});
